import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthnService } from '../../../services/authn.service';
import { CaptchaService } from '../../../services/captcha.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  message: string = '';
  loading: boolean = false;
  private captchaToken: string | null = null;
  // honeypot: real users never fill this hidden field
  hpField = '';
  formLoadedAt = 0;

  constructor(private formBuilder: FormBuilder, public authnService: AuthnService, private router: Router,
    private messageService: MessageService, private captchaService: CaptchaService) {
    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    this.formLoadedAt = Date.now();
  }

  async requestReset() {
    if (this.resetForm.valid) {
      this.loading = true;
      this.message = 'Sending...';
      // solve the proof-of-work captcha at submit time, so the token is fresh
      try {
        this.captchaToken = await this.captchaService.execute('resetpassword');
      } catch (e) {
        this.loading = false;
        console.error('captcha failed', e);
        this.message = 'Captcha verification failed; please try again';
        this.messageService.showMessage(this.message, true);
        return;
      }
      // clear any browser-autofilled honeypot value; real users run JS, so the
      // field is empty for them — only non-JS bots leave it filled
      this.hpField = '';
      this.authnService.requestPasswordReset(this.resetForm.controls['email'].value, this.captchaToken,
        this.hpField, this.formLoadedAt)
        .subscribe({
          next: (v) => {
            this.loading = false;
            this.message = v.message || 'If the email address is known, a password reset link has been sent';
            this.messageService.showMessage(this.message, false);
          },
          error: e => {
            this.loading = false;
            console.error('error', e);
            this.message = e.error?.message || 'Server connection failure';
            this.messageService.showMessage(this.message, true);
          }
        });
    }
  }

  backToLogin() {
    this.router.navigate(['/auth/signin']);
  }
}
